import React, { useState, useEffect, useRef } from "react";
import { Button, FormControl, Form } from "react-bootstrap";
import user from "../../assets/images/chat/user.png";
// import user1 from "../../assets/images/chat/user1.png";
// import user2 from "../../assets/images/chat/user2.png";
import emoji from "../../assets/images/chat/emoji.svg";
import icon from "../../assets/images/chat/dots.png";
import "./chat.css";
import ChatContent from "./chatcontent";
import Modals from "../modals/modals";

const Chat = ({ show, setShow }) => {
  const [open, setOpen] = useState();
  const [menu, setMenu] = useState();
  const [close, setClose] = useState();
  const [view ,setView] = useState(false);
  const handleChat = (e) => {
    if(e.target.value === '/'){
      setOpen(true);
    }
    else{
      setOpen(false);
    }
  };

const handleChatDropdown = (item) => {
   setMenu(item);
   setClose(!close);
}

const useOutsideAlerter = (ref) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
          // setMenu(false);
          setClose(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
};
const wrapperRef = useRef(null);
useOutsideAlerter(wrapperRef);

const handleCloseChat  = () => {
  setShow(!show);
  localStorage.setItem("chat" , true);
  if(show){
    localStorage.removeItem("chat");
  }
}

const handleTip = () => {
  setView(!view);
  console.log('fjdhjdh')
}
  return (
    <div className="chat">
      <div className="chat-view">
        <h2>
          192 Online{" "}
          <span
            onClick={handleCloseChat}
            className="hide-btn"
            role="presentation"
          >
            <i className={`fa ${show ? `fa-envelope` : `fa-angle-left`}`} />
            <i
              className={`mobile-icon fa ${
                show ? `fa-angle-right` : `fa-envelope`
              }`}
            />
          </span>
        </h2>
        <div className="chat-content">
          <div className="chat-box">
            {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map((item) => {
              return (
                <div key={item}>
                  <div className="container1">
                    <div className="chat-user">
                      <div className="chat-user-pic">
                        <img src={user} alt="Avatar" />
                      </div>
                      <div className="chat-user-info">
                        <div className="user-chat-details">
                          <h4>
                            <span className="pink-badge">89</span> Austistic
                            Panda
                          </h4>
                          <p>
                            Bro, this guy could have bought Afghanistan
                            military...
                          </p>
                        </div>
                        <div className="chat-icon-menu" onClick={() => handleChatDropdown(item)}>
                          <img src={icon} alt="icon" />
                        </div>
                      </div>
                    </div>
                    {menu === item && close ? <div className="menu-mention-popup" ref={wrapperRef}><ChatContent handleTip={handleTip}  /></div> : ""}
                  </div>

                  {/* <div className="container1">
                    <div className="chat-user">
                      <div className="chat-user-pic">
                        <img src={user1} alt="Avatar" />
                      </div>
                      <div className="chat-user-info">
                        <div className="user-chat-details">
                          <h4>
                            <span className="yellow-badge">89</span> Austistic
                            Panda
                          </h4>
                          <p>wrong color pal</p>
                        </div>
                        <div className="chat-icon-menu"  onClick={() => handleChatDropdown(item)}>
                          <img src={icon} alt="icon" />
                        </div>
                      </div>
                    </div>
                    {menu === item && close ? <div className="menu-mention-popup" ref={wrapperRef}><ChatContent  /></div> : ""}
                  </div> */}

                  {/* <div className="container1">
                    <div className="chat-user">
                      <div className="chat-user-pic">
                        <img src={user2} alt="Avatar" />
                      </div>
                      <div className="chat-user-info">
                        <div className="user-chat-details">
                          <h4>
                            <span className="blue-badge">89</span> Austistic
                            Panda
                          </h4>
                          <p>wrong color pal</p>
                        </div>
                        <div className="chat-icon-menu"  onClick={() => handleChatDropdown(item)}>
                          <img src={icon} alt="icon" />
                        </div>
                      </div>
                    </div>
                    {menu === item && close ? <div className="menu-mention-popup" ref={wrapperRef}><ChatContent  /></div> : ""}
                  </div> */}
                </div>
              );
            })}
          </div>
          <div className="chat-footer">
            <Form>
              <FormControl
                placeholder="Type your message..."
                onChange={(e) => handleChat(e)}
              />

              <Button type="submit">
                <img src={emoji} alt="" />
              </Button>
              {open ? <ChatContent  handleTip={handleTip} /> : ""}
            </Form>
          </div>
        </div>
      </div>
      <Modals view={view} setView={setView} />
    </div>
  );
};

export default Chat;
